
import '@babel/polyfill';
import ESPromise from 'es6-promise';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import enginePc from 'enginePc';
import zxyI18n from 'zxyI18n';
// import VueAliplayer from 'vue-aliplayer';
import App from './App.vue';
import router from './router';
import store from './store/index';
import enLocale2 from './lang/en';
import znLocale2 from './lang/cn';
import useful from './util/vue-extend';
import './util/zxy-ui';
import './util/custom-directives';
import './util/custom-filters';
import './assets/styles/postcss/index.css';
import * as oauth from './util/oauth';
import './util/buried-point';
import directives from './directives'; // 指令集
import myCoin from './util/mount-coin';
import './filters';
import './util/safe-link';
// Vue.use(VueAliplayer);

ESPromise.polyfill();
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(useful);
// 引擎组件和ant注册
Vue.use(enginePc);
Vue.use(zxyI18n);
Vue.use(directives);
Vue.use(myCoin);

const messages = {
    en: {
        ...enLocale2
    },
    cn: {
        ...znLocale2
    }
};
let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'cn';
const location = window.location;
const i18n = new VueI18n({ // 国际化
    locale: language,
    messages,
    fallbackLocale: 'cn',
    silentTranslationWarn: true // 浸默控制台vue-i18n warn
});

window.i18n = i18n;

const options = {
    returnTo: `${window.location.protocol}//${window.location.host}`,
    clientId: process.env.VUE_APP_ClientId,
    provider: process.env.VUE_APP_Provider
};
store.commit('setI18N', i18n);
store.commit('setRouter', router);
store.commit('setPublicComponent', Vue.prototype);

const createIns = () => {
    const instance = new Vue({ // 初始化application
        router,
        store,
        i18n,
        render: (h) => {
            return h(App);
        },
    });
    instance.$on('vueBeginCreate', (callBack) => {
        instance.$off('vueBeginCreate');
        instance.$destroy();
        window.zxyVue = createIns();
        callBack();
        callBack = null;
    });
    instance.$on('zxyI18nInit', (emitLang) => {
        language = emitLang || null;
        if (location.href.split('#')[0].endsWith('admin/')) language = 'cn';
        zxyI18n.init({
            vueI18n: i18n,
            lang: language,
            langType: 2,
            orgId: window.app.global.organization.id
        }).then(() => {
            // 初始化成功  设置本地语言  缓存中文
            if (!location.href.split('#')[0].endsWith('admin/')) localStorage.lang = language;
            if (language !== 'cn') {
                zxyI18n.init({
                    vueI18n: i18n,
                    lang: 'cn',
                    langType: 2,
                    orgId: window.app.global.organization.id,
                    cache: true
                });
            }
        }).catch(() => {
            if (language !== 'cn') {
                // 初始化失败 修改语言为中文继续初始化
                localStorage.lang = 'cn';
                window.location.onload();
            } else {
                // // 初始化中文失败 捕获初始化失败抛出的异常，使用本地文件初始化
                // const langPackage = require('./lang/language.json');
                // i18n.mergeLocaleMessage('cn', langPackage);
                // i18n.locale = 'cn';
                // localStorage.lang = 'cn';
            }
        });
    });
    return instance;
};
const setup = () => {
    // console.log('启动VueAPP');
    oauth.initOauth(store.state.app).then((res) => {
        oauth.setOauth(store.state.app, options, res); // 设置登录相关的token
        store.commit('setOauth'); // 设置登录相关的token和http全局参数
        window.zxyVue = createIns();
        window.zxyCreateVue = createIns;
    });
};
export default { setup };
